import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  name: 'growth-chart',
  extends: Line,
  props: [
    'scale'
  ],
  mixins: [reactiveProp],
  data() {
    return {
      options: {
        borderCapStyle: 'butt',
        maintainAspectRatio: false,
        tooltips: {
          mode: 'index',
          callbacks: {
              label: function(tooltipItem, data) {
                  return tooltipItem.yLabel.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
              }
          }
        },
        scales: {
          yAxes: [{
            ticks: {
                userCallback: function(value, index, values) {
                    return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                }
              }
            }]
        },
      }
    }
  },
  watch: {
    scale(value) {
      const scaleString = value? 'logarithmic' : 'linear'
      this.options.scales.yAxes[0].type = scaleString
      this.renderChart(this.chartData, this.options)
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}